export const da = {
  consent: {
    title: 'Hjemmesiden bruger cookies',
    text: 'For at give dig den bedste oplevelse bruger vi cookies på gjensidige.dk. Vi bruger både egne cookies og cookies fra tredjeparter. Hvis du accepterer alle cookies, giver du samtykke til, at vi registrerer hvordan du bruger hjemmesiden, gøre markedsføring mere relevant, giver dig mulighed for at bruge yderligere funktionalitet og indsamle, behandle og videregive oplysninger om dig. Til enhver tid kan du tilbagekalde dit cookiesamtykke. <a href="/persondata-og-cookies">Du kan læse mere i vores cookie- og persondatapolitik.</a>',
    accept: 'OK, helt fint med mig',
    necessary: 'Kun nødvendige',
    edit: 'Ret indstilinger',
    close: 'Luk modalt vindue'
  },
  preferences: {
    title: 'Ret indstillinger',
    text: 'Vælg "Gem indstillinger", hvis du accepterer brugen af cookies på vores hjemmeside. Du kan også ændre indstillingerne. Det valg, du foretager, er kun gyldigt for den enhed, du bruger i øjeblikket. Hvis du vil foretage det samme valg på dine andre enheder, skal du gentage valget på disse enheder. Enheder kan være pc, mobil eller tablet.',
    necessary_title: 'Nødvendige',
    necessary_text:
      'Disse cookies er nødvendige for at gjensidige.dk virker og kan derfor ikke fjernes. De sikrer, at vores webshop og selvbetjening fungerer og tilføjer samtidigt et lag af sikkerhed.',
    toggles: [
      {
        id: 'analytics',
        title: 'Statistik',
        text: 'Vi bruger disse cookies til at forstå, hvordan du anvender vores hjemmeside, så vi kan forbedre brugeroplevelsen og rette eventuelle fejl.'
      },
      {
        id: 'personalization',
        title: 'Funktionelle',
        text: 'Disse cookies gør det muligt at tilpasse indholdet og udseendet af gjensidige.dk baseret på fx om du besøger os fra en smartphone og er kunde hos os, så du møder det indhold, der er mest relevant for dig.'
      },
      {
        id: 'display_ads',
        title: 'Markedsføring',
        text: 'Disse cookies bruges til at spore besøgende på tværs af gjensidige.dk og andre hjemmesider, så du altid møder den mest relevante rådgivning og annoncering fra os via tredjeparts-cookies.'
      }
    ],
    save: 'Gem indstillinger'
  }
};

export const en = {
  consent: {
    title: 'We too make use of cookies',
    text: 'Some cookies are essential to make our website work securely. Others are used to gather data, remember your settings and improve our services. We also use cookies from third parties to deliver their content.',
    accept: 'Accept cookies',
    necessary: 'Reject cookies',
    edit: 'Set cookie preferences',
    close: 'Close modal'
  },
  preferences: {
    title: 'Set your cookie preferences',
    text: 'We make use of cookies to remember your preferences and improve our services. Tailor your experience for this device by accepting only some of our cookies.',
    necessary_title: 'Necessary',
    necessary_text:
      'Some cookies are necessary to keep the site secure and functional. They cannot be rejected',
    toggles: [
      {
        id: 'analytics',
        title: 'Statistics',
        text: "We use cookie to understand how you're using the site, so that we can continuously improve your user experience and fix errors."
      },
      {
        id: 'personalization',
        title: 'Functionality',
        text: 'These cookies ensure the content is relevant to you. They allow us to adjust our communication and adapt the design to your device.'
      },
      {
        id: 'display_ads',
        title: 'Marketing',
        text: 'Some cookies are used to trace users across the site and other websites, so that you always get the most relevant content through third party cookies.'
      }
    ],
    save: 'Save preferences'
  }
};

export const nb = {
  consent: {
    title: 'Vi bruker informasjonskapsler (cookies)',
    text: 'For å gi deg en god opplevelse og sørge for at alt fungerer som det skal på nettsidene våre, bruker vi informasjonskapsler. På denne måten kan vi forbedre nettsidene og vise deg mer relevant innhold og markedsføring. Du kan alltid <a href="/personvern-og-sikkerhet/informasjonskapsler-cookies">endre valgene dine og lese mer om informasjonskapsler</a>.',
    accept: 'Godta informasjonskapsler',
    necessary: 'Kun nødvendige',
    edit: 'Endre innstillinger',
    close: 'Lukk modalvindu'
  },
  preferences: {
    title: 'Endre innstillinger',
    text: 'Velg «Lagre innstillinger» om du godtar bruken av informasjonskapsler på nettsidene våre. Du kan også endre innstillingene. Valget du gjør er kun gjeldende for den enheten du bruker nå. Om du vil gjøre samme valg på de andre enhetene dine, må du gjenta valget på disse enhetene. Enheter kan være PC, mobil eller nettbrett.',
    necessary_title: 'Nødvendige',
    necessary_text:
      'Nettsiden vår trenger disse informasjonskapslene for å fungere ordentlig. De er alltid aktivert og sørger for eksempel\u202ffor å sikre at nettbutikken vår og påloggede tjenester fungerer og er sikre.',
    toggles: [
      {
        id: 'analytics',
        title: 'Statistikk',
        text: 'Disse informasjonskapslene hjelper oss å forstå hvordan nettsidene våre brukes slik at vi kan forbedre opplevelsen og funksjonaliteten på sidene. Vi kan for eksempel bruke statistikk for å se hvor mange som besøker de ulike nettsidene våre.'
      },
      {
        id: 'personalization',
        title: 'Brukeradferd og relevant innhold',
        text: 'Disse informasjonskapslene brukes for å samle inn data på individnivå om hvordan du bruker nettsidene våre. Dataene kan vi bruke til blant annet å forbedre løsningene våre, gi deg tilpasset innhold på nettsidene og mer relevant markedsføring i andre kommunikasjonskanaler som for eksempel e-post dersom du er kunde hos oss.'
      },
      {
        id: 'display_ads',
        title: 'Markedsføring',
        text: 'Disse informasjonskapslene brukes for annonsering og målrettet markedsføring på andre nettsider enn gjensidige.no. Informasjonskapslene brukes til å forstå hva du er interessert i på våre nettsider for så å tilby mer relevant markedsføring på andres nettsider.'
      }
    ],
    save: 'Lagre innstillinger'
  }
};

export const sv = {
  consent: {
    title: 'Cookies',
    text: 'Vi använder cookies för att ge dig en bättre upplevelse. De säkerställer att du ser det mest relevanta innehållet och att vi kan förbättra upplevelsen på vår webbplats. Läs mer om cookies på gjensidige.se.',
    accept: 'Jag godkänner',
    necessary: 'Endast nödvändiga',
    edit: 'Avancerade inställningar',
    close: 'Stäng modalt fönster'
  },
  preferences: {
    title: 'Avancerade inställningar',
    text: 'Några cookies används till anonym statistik och andra sätts av tredjepartstjänster. Du kan välja vilka cookies du samtycker till genom att aktivera eller avaktivera typen av cookies och sedan klicka på "Spara val".',
    necessary_title: 'Nödvändiga',
    necessary_text:
      'Vår webbplats behöver dessa cookies för att fungera på rätt sätt. De är alltid aktiverade och ser t.ex. till att vår webbshop och inloggade tjänster fungerar och tillför samtidigt ett lager av säkerhet.',
    toggles: [
      {
        id: 'analytics',
        title: 'Statistik',
        text: 'Dessa cookies hjälper oss att förstå hur besökare använder vår webbplats, t.ex. vilka sidor du besöker, så att vi kan förbättra användarupplevelsen och rätta eventuella fel.'
      },
      {
        id: 'personalization',
        title: 'Personligt anpassade',
        text: 'Dessa cookies anpassar innehållet och utseendet på vår webbplats baserat på om du t.ex. besöker oss från en smartphone eller är kund hos oss, så att du möts av det innehåll som är mest relevant för dig.'
      },
      {
        id: 'display_ads',
        title: 'Relevant marknadsföring',
        text: 'Dessa cookies används i plattformar för annonsering och riktad marknadsföring. De används för att förstå besökares intressen för att erbjuda en mer relevant och personlig anpassad upplevelse. Detta innebär att du kan se annonser på webbplatser som tillhör tredjepart baserat på ditt beteende och vad du visar intresse för på vår webbplats.'
      }
    ],
    save: 'Spara val'
  }
};
